<template>
  <PaOverlayModal
   :isOpen="isOpenEditor"
   :appendClass="['pa-connection-editor']"
   :position="{top: 0}"
   :contentTransitionName="'pa-simple-fade'"
   :couldOverlaySwipeClose="false"
   @afteredAfterEnterContent="handleAfterdAfterEnterContent"
   @closeOverlayModal="handleCloseOverlay"
  >
    <div class="editor-box" ref="editorBox">
      <PASimpleTextEditor
       :inputText="editorText"
       :textareaPlaceholder="editorOptions.placeholder"
       :textMaximumSize="editorOptions.textSize"
       :textareaDisabled="editorOptions.textareaDisabled"
       :couldEditorExpand="editorOptions.couldEditorExpand"
       :isEditorLoading="editorOptions.isEditorLoading"
       :shouldShowInkCounter="editorOptions.shouldShowInkCounter"
       :inkCounterDisplayStyle="'showEstimateRemaining'"
       :inkCountBannerPopperArrowPosition="'bottom'"

       @changeText="handleChangeText"
       @changeImagesBlob="handleChangeImagesBlob"
       @changeEditorExpand="handleChangeEditorExpand"
       @changeTextLimitOverd="handleChangeTextLimitOverd"
      />

      <div class="button-field">
        <button
         class="button pa-button-submit"
         :class="submitButtonClass"
         :disabled="isSubmitButtonDisabled"
         @click.prevent="handleSubmit"
        >投入</button>

        <button
         class="button pa-button-cancel"
         :disabled="isCancelButtonDisabled"
         @click.prevent="handleCancel"
        ><span>中断</span></button>
      </div>
    </div>
  </PaOverlayModal>
</template>

<script>
import safeAreaInsets from 'safe-area-insets'

import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PASimpleTextEditor from '@/components/Parts/PASimpleTextEditor/PASimpleTextEditor.vue'

import TextSendWarningMixins from '@/mixins/TextSendWarningMixins.js'

import {UpdateInsertConnectionPodMessage} from '@/graphql/mutations/Pod.graphql'
import {GetMessageData} from '@/graphql/queries/ConnectionPod.graphql'

import {GetModalAlertInfomations} from '@/graphql/queries/Character.graphql'

export default {
  components  : {
    PaOverlayModal,
    PASimpleTextEditor
  },

  mixins : [
    TextSendWarningMixins
  ],

  data(){
    return {
      isLoading                 : false,

      // Editor
      editorText                : '',
      editorAttachedImagesBlob  : [],
      
      editorOptions             : {
        placeholder           : '言葉を投入',
        textSize              : 120,
        textareaDisabled      : false,
        couldEditorExpand     : true,
        isEditorLoading       : false,
        shouldShowInkCounter  : false
      },
      isTextLimitOverd    : false,

      // SubmitButton
      submitButtonClass         : {
        'is-loading'      : false
      },

      isSubmitButtonDisabled    : false,

      // CancelButton
      isCancelButtonDisabled    : false,
    };
  },

  apollo : {
    modalAlertInfomations : {
      query: GetModalAlertInfomations
    },
  },

  computed    : {
    isOpenEditor(){
      return this.$store.state.createButton.isOpenConnectionEditor;
    },

    displayHeight(){
      return window.innerHeight;
    },

    podRoomId(){
      return this.$store.state.createButton.podRoomId;
    },

    replyPodMessageId(){
      return this.$store.state.createButton.replyPodMessageId;
    }
  },

  watch : {
    replyPodMessageId : {
      handler(value){
        if(value === null){
          this.editorOptions.placeholder = '言葉を投入';
        }else{
          this.editorOptions.placeholder = '返信を記述';
        }
      },
      immediate: true
    },

    isLoading : {
      handler(value){
        if(value === true){
          this.editorOptions.isEditorLoading = true;

          this.isSubmitButtonDisabled = true;

          this.isCancelButtonDisabled = true;

          this.submitButtonClass['is-loading'] = true;

        }else{
          this.editorOptions.isEditorLoading = false;

          this.isSubmitButtonDisabled = false;

          this.isCancelButtonDisabled = false;

          this.submitButtonClass['is-loading'] = false;
        }
      }
    }
  },

  methods     : {
    handleChangeText(value){
      this.editorText = value;
    },

    handleChangeImagesBlob(data){
      this.editorAttachedImagesBlob = data;
    },

    handleChangeTextLimitOverd(value){
      this.isTextLimitOverd = value;
    },

    handleChangeEditorExpand(value){
      if(typeof this.$refs.editorBox === 'undefined') return;

      if(value === true){
        this.$refs.editorBox.style.height = ( this.displayHeight - safeAreaInsets.bottom - (8*2) ) + 'px';
      }else{
        this.$refs.editorBox.style.minHeight  = '260px';
        this.$refs.editorBox.style.height     = 'auto';
      }
    },

    handleCloseOverlay(){
      this.handleCloseModal();
    },

    handleCloseModal(){
      this.editorOptions.shouldShowInkCounter = false;
      
      this.$store.dispatch({
        type        : 'createButton/updateOpenEditor',
        editorType  : 'connection',
        value       : false,
      });
    },

    async handleSubmit(){
      if(this.editorText.length === 0) return;

      if(this.isTextLimitOverd){
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;メッセージの文字数は'+this.editorOptions.textSize+'文字以内でお願いいたします。',
          status      : 'error',
          hasControl  : true,
          autoClose   : 3000
        }, {root:true});
      }else{
        this.isLoading = true;

        await this.UXWaiting(1000);

        const submitBehaviour = async () => {
          this.$store.dispatch({
            type            : 'textEditorWarningModal/updateOpenModal',
            isSubmitLoading : true,
          });

          await this.UXWaiting(500);

          this.$store.dispatch({
            type            : 'textEditorWarningModal/updateOpenModal',
            value           : false,
            isSubmitLoading : false
          });

          const result = await this.executeCreateConnectionMessage({
            podRoomId       : this.podRoomId,
            podMessageId    : null,
            body            : this.editorText,
            replyMessageId  : this.replyPodMessageId,
            images          : this.editorAttachedImagesBlob,
          });

          if(result === true){
            this.$apollo.queries.modalAlertInfomations.refetch();

            this.editorText = '';

            this.isLoading = false;
            
            this.handleCloseModal();
          }
        };

        const cancelBehaviour = () => {
          this.$store.dispatch({
            type  : 'textEditorWarningModal/updateOpenModal',
            value : false,
          });

          this.isLoading = false;
        };

        if( this.shouldSkipWarningModal() ){
          await submitBehaviour();
        }else{
          this.$store.dispatch({
            type                  : 'textEditorWarningModal/updateOpenModal',
            value                 : true,
            handleSubmitFunction  : submitBehaviour,
            handleCancelFunction  : cancelBehaviour
          });
        }
      }
    },

    handleCancel(){
      this.handleCloseModal();
    },

    executeCreateConnectionMessage(payload){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UpdateInsertConnectionPodMessage,
          variables : {
            podRoomId       : payload.podRoomId,
            podMessageId    : payload.podMessageId,
            body            : payload.body,
            replyMessageId  : payload.replyMessageId,
            images          : payload.images
          },
          update    : (store, {data:{UpdateInsertConnectionPodMessage:{podMessage, parentPodMessage}}}) => {
            store.writeQuery({
              query     : GetMessageData,
              variables : {
                id  : podMessage.id
              },
              data      : {
                podMessage : podMessage
              }
            });

            if(parentPodMessage !== null){
              store.writeQuery({
                query     : GetMessageData,
                variables : {
                  id  : parentPodMessage.id
                },
                data      : {
                  podMessage : parentPodMessage
                }
              });
            }else{
              this.$store.dispatch({
                type      : 'connection/updatePodRoomData',
                podRoomId : payload.podRoomId,
                list      : [
                  {
                    id  : podMessage.id
                  }
                ],
                behaviour : 'refresh'
              });
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(error);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            const errorMessageTextSet = {
              'default'                               : "エラーが発生しました。",
              'Could not enough character ink body'   : "&nbsp;インクが足りません。",
              'This text include In-Acceptable wrod.' : "&nbsp;こちらの内容はご投稿いただくことができかねます。",
            };

            let errorMessageText = '';

            switch(simpleErrorSet.firstError.field){
              case 'images.0':
              case 'images.1':
                errorMessageText = '&nbsp;'+simpleErrorSet.firstError.message;
              break;

              case 'body':
                if(typeof errorMessageTextSet[simpleErrorSet.firstError.message] !== 'undefined'){
                  errorMessageText = errorMessageTextSet[simpleErrorSet.firstError.message];
                }else{
                  errorMessageText = errorMessageTextSet['default'];
                }
              break;
            }

            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : errorMessageText,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    handleAfterdAfterEnterContent(){
      this.editorOptions.shouldShowInkCounter = true;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-connection-editor{
  overflow-y: scroll;

  .pa-contents{
    position: fixed;
    top:0;
    left:0;
    z-index: 401;
    width: 100vw;
    height: 100vh;

    .editor-box{
      position:absolute;
      width:100vw;
      min-height:260px;
      top:0;
      left:0;
      padding:1.5rem 0;
      box-sizing: border-box;

      display:flex;
      flex-direction: column;


      .button-field{
        flex-grow: 0;
        display:flex;
        flex-direction: row-reverse;
        box-sizing: border-box;
        width: 98%;
        margin: .3rem auto 0;

        @media screen and (min-width: $desktop) {
          width:632px;
        }

        .pa-button{
          &-submit{
            margin-right:.2rem;
            padding:0;
            text-align: center;
            border-radius: 4px;
            width:5rem;
            font-size:1.2rem;
            border:2.3px solid #723E14;
            background-color: #874D26;
            color:#E8DFD9;
            cursor: pointer;
            user-select: none;
            height:auto;
          }

          &-cancel{
            background-color: inherit;
            border:0;
            padding:0;
            color:#BBA891;
            font-size: 1rem;
            line-height: 1.9;
            margin-right:.5rem;
            cursor: pointer;
            user-select: none;

            span{
              padding:0 .1rem;
              border-bottom:2px solid #BBA891;
            }
          }
        }
      }
    }
  }
}
</style>